import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IndividualLicenseModel } from '../../model/individualLicenseModel';
import { environment } from '../../../environments/environment';

@Injectable()
export class IndividualLicenseService {

  private notifyIndividualLicenseID : EventEmitter<number> = new EventEmitter<number>() ;


  constructor(private http : HttpClient) { }

  getIndividualLicense(individualID : number){
    const params = new HttpParams()
    .set('individualLicenseID', individualID.toString());
      return this.http.get<IndividualLicenseModel>(environment.server_url+"/api/IndividualLicense", {params});
  }

  getNotifyIndividualLicenseID(){
    return this.notifyIndividualLicenseID;
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/individual-license.service.ts